module.exports = __webpack_public_path__ + "static/mobile-tabbed-arrow-right.634eaafc.svg";